// 历史交易金额
const Form1 = {
    layout:'vertical',
    labelAlign:'right',
    formData:{},
    formField:[]
}

// 逾期状态
const Form2 = {
    layout:'vertical',
    labelAlign:'right',
    formData:{},
    formField:[]
}

// 销售经理查看字段
const Form3 = {
    layout:'vertical',
    labelAlign:'right',
    formData:{},
    formField:[]
}

export {
    Form1,
    Form2,
    Form3,
}